// src/redux/features/Auth/authSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { 
  requestOtpThunk, 
  verifyOtpThunk, 
  setUsernameThunk,
  requestPhoneChangeThunk,
  verifyPhoneChangeThunk
} from "./authThunk";

const initialState = {
  phone: "",
  userInfo: null,
  isNewUser: false,
  otpSent: false,
  loading: false,
  error: null,
  // ===== تغییر شماره تلفن =====
  phoneChangeStep: 'idle', // 'idle' | 'requested' | 'verified'
  newPhone: '',
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearAuthState: (state) => {
      state.phone = "";
      state.userInfo = null;
      state.isNewUser = false;
      state.otpSent = false;
      state.loading = false;
      state.error = null;
      state.phoneChangeStep = 'idle';
      state.newPhone = '';
      localStorage.removeItem("userInfo");
    },
    updateTokens: (state, action) => {
      if (state.userInfo) {
        state.userInfo.access = action.payload.access;
        state.userInfo.refresh = action.payload.refresh;
        localStorage.setItem("userInfo", JSON.stringify(state.userInfo));
      }
    },
    logout: (state) => {
      localStorage.removeItem("userInfo");
      return { ...initialState };
    },
    resetPhoneChange: (state) => {
      state.phoneChangeStep = 'idle';
      state.newPhone = '';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // ---- Request OTP ----
    builder.addCase(requestOtpThunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(requestOtpThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.phone = action.meta.arg;
      state.otpSent = true;
      state.error = null;
    });
    builder.addCase(requestOtpThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.detail || "خطا در ارسال کد تایید";
    });

    // ---- Verify OTP ----
    builder.addCase(verifyOtpThunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(verifyOtpThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.isNewUser = action.payload.is_new_user || false;
      state.userInfo = {
        access: action.payload.access,
        refresh: action.payload.refresh,
        id: action.payload._id,
        first_name: action.payload.first_name || "",
        last_name: action.payload.last_name || "",
        name: action.payload.name || "",
        email: action.payload.email || "",
        username: action.payload.username || "",
        isAdmin: action.payload.isAdmin || false,
        phone: action.payload.phone || state.phone,
      };
      localStorage.setItem("userInfo", JSON.stringify(state.userInfo));
      state.error = null;
    });
    builder.addCase(verifyOtpThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.detail || "کد نامعتبر است";
    });

    // ---- Set Username ----
    builder.addCase(setUsernameThunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(setUsernameThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.isNewUser = false;
      if (state.userInfo) {
        state.userInfo.first_name = action.payload.first_name;
        state.userInfo.last_name = action.payload.last_name || "";
        state.userInfo.name = action.payload.name || `${action.payload.first_name} ${action.payload.last_name || ''}`.trim();
        localStorage.setItem("userInfo", JSON.stringify(state.userInfo));
      }
      state.error = null;
    });
    builder.addCase(setUsernameThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.detail || "خطا در ثبت نام کاربری";
    });

    // ============================================
    // 📱 تغییر شماره تلفن
    // ============================================

    // Request Phone Change
    builder.addCase(requestPhoneChangeThunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(requestPhoneChangeThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.phoneChangeStep = 'requested';
      state.newPhone = action.meta.arg;
      state.error = null;
    });
    builder.addCase(requestPhoneChangeThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.detail || "خطا در ارسال کد تایید";
    });

    // Verify Phone Change
    builder.addCase(verifyPhoneChangeThunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(verifyPhoneChangeThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.phoneChangeStep = 'verified';
      if (state.userInfo) {
        state.userInfo.phone = state.newPhone;
        localStorage.setItem("userInfo", JSON.stringify(state.userInfo));
      }
      state.error = null;
    });
    builder.addCase(verifyPhoneChangeThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.detail || "کد نامعتبر است";
    });
  },
});

export const { clearAuthState, updateTokens, logout, resetPhoneChange } = authSlice.actions;
export default authSlice.reducer;